import React, { Component } from "react";
import axios from "axios";
import { Contact, PageHeader, PublicationListBody } from "../components";
import { API_MAIN, API_PUBLICATIONS, API_PUBLICATIONS_CATEGORY } from "../utils/constants";

const publicationText = {
  id: {
    title: "Publikasi Kami",
    subtitle:
      "Kumpulan buku, working paper, dan publikasi lain yang dapat dijelajahi berdasarkan kategori.",
  },
  en: {
    title: "Our Publications",
    subtitle:
      "A curated list of books, working papers, and other publications grouped by category.",
  },
};

export class Publication_list extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      main: [],
      categories: [],
      total: 0,
      total_all: 0,
      perpage: 10,
      query: new URLSearchParams(this.props.location.search).get("s"),
      category_query: new URLSearchParams(this.props.location.search).get("cat") || "",
    };
  }

  componentDidMount() {
    this.getItems(this.props.match.params.page || 1);
    this.getMain();
    this.getCategories();
  }

  componentDidUpdate(prevProps) {
    const currentPage = this.props.match.params.page;
    const prevPage = prevProps.match.params.page;
    const query = new URLSearchParams(this.props.location.search).get("s");
    const category_query =
      new URLSearchParams(this.props.location.search).get("cat") || "";

    if (
      currentPage !== prevPage ||
      this.state.query !== query ||
      this.state.category_query !== category_query
    ) {
      this.setState({ query, category_query });
      if (this.state.query !== query) {
        this.getCategories(query);
      }
      this.getItems(currentPage || 1);
    }
  }

  getMain() {
    axios
      .get(API_MAIN)
      .then((res) => {
        this.setState({ main: res.data.main });
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getCategories(searchQuery = this.state.query) {
    axios
      .get(API_PUBLICATIONS_CATEGORY)
      .then((res) => {
        const categories = res.data.categorys || [];

        this.setState({ categories });
        this.getCategoryCounts(categories, searchQuery);
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getCategoryCounts(categories, searchQuery) {
    const searchSuffix = searchQuery
      ? `&search=${encodeURIComponent(searchQuery)}`
      : "";
    const categoryRequests = (categories || []).map((category) =>
      axios
        .get(`${API_PUBLICATIONS}?pagin=1&category=${category.ID}${searchSuffix}`)
        .then((res) => ({
          ...category,
          TOTAL: res.data.total || 0,
        }))
        .catch(() => ({
          ...category,
          TOTAL: 0,
        }))
    );

    Promise.all([
      axios
        .get(`${API_PUBLICATIONS}?pagin=1${searchSuffix}`)
        .then((res) => res.data.total || 0)
        .catch(() => 0),
      ...categoryRequests,
    ]).then(([allTotal, ...categoriesWithCount]) => {
      this.setState({
        categories: categoriesWithCount,
        total_all: allTotal,
      });
    });
  }

  getItems(page) {
    const query = new URLSearchParams(this.props.location.search).get("s");
    const category_query =
      new URLSearchParams(this.props.location.search).get("cat") || "";
    let url = API_PUBLICATIONS + "?pagin=" + page;

    if (query) {
      url += "&search=" + query;
    }

    if (category_query) {
      url += "&category=" + category_query;
    }

    axios
      .get(url)
      .then((res) => {
        this.setState({
          items: res.data.news || [],
          total: res.data.total || 0,
          perpage: res.data.limit_per_page || 10,
        });
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const {
      items,
      main,
      categories,
      total,
      total_all,
      perpage,
      query,
      category_query,
    } =
      this.state;
    const lang = window.lang || "id";
    const copy = publicationText[lang] || publicationText.id;
    const param = {
      title: copy.title,
      subtitle: copy.subtitle,
      breadcrumb: copy.title,
    };

    return (
      <main>
        <div role="main" className="main">
          <PageHeader param={param} />
          <PublicationListBody
            items={items}
            page={this.props.match.params.page || 1}
            total={total}
            total_all={total_all}
            perpage={perpage}
            query={query}
            categories={categories}
            category_query={category_query}
          />
          <Contact data={main} />
        </div>
      </main>
    );
  }
}

export default Publication_list;
